import React from "react";
import I18n from "../../I18n";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosButton, SovosIcon, SovosBox } from "mosaic-react";
import { DocumentErrorFilled } from "mosaic-react-icons";
import { useTheme } from "mosaic-react/styles";
import dompurify from "dompurify";

const FileMessageSalesSubmissionInformation = (props) => {
    const { mergeRepository, modules } = props;
    const { params, history } = useGlobalValue();
    const { projectId, fiscalYear, importId, locale } = params;
    let { status, files } = mergeRepository || {};
    const theme = useTheme();
    let localeToUse = "en";
    let sanitizedCustomUrl = undefined;

    const messageToDisplay = {
        1: "All files are Submitted",
        2: "Missing some files to submit",
        3: "Submission is on going",
    };
    const colorToDisplay = {
        1: theme.palette.success.main,
        2: theme.palette.error.light,
        3: theme.palette.dataVisualization.orange40,
    };

    if (status && status === 2 && files && files.length) {
        localeToUse = locale;
        sanitizedCustomUrl = `/${localeToUse}/${projectId}/${fiscalYear}/${importId}/repository/folders`;
    }
    const checkSubmissionModule = (modules || []).includes("submission_file");
    const backgroundColor = colorToDisplay[status];
    return (
        <SovosBox
            sx={{
                maxWidth: "100% !important",
                width: "100% !important",
                margin: "0px !important",
            }}
        >
            {checkSubmissionModule && importId === "full" && status && status !== 1 ? (
                <SovosBox
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: backgroundColor,
                        padding: "16px 24px",
                        borderRadius: `${theme.shape.borderRadiusSmall}`,
                        width: "100%",
                        boxSizing: "border-box",
                    }}
                >
                    <SovosBox
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            alignContent: "stretch",
                            marginLeft: "8px",
                        }}
                    >
                        <SovosBox>
                            {messageToDisplay[status] === messageToDisplay[2] ? (
                                <SovosIcon>
                                    <DocumentErrorFilled color="primary" />
                                </SovosIcon>
                            ) : (
                                ""
                            )}
                        </SovosBox>
                        <SovosBox
                            sx={{
                                marginLeft: "8px",
                            }}
                        >{I18n.translate`${messageToDisplay[status] || "N/A"}`}</SovosBox>
                    </SovosBox>
                    <SovosBox
                        sx={{
                            marginRight: "4px",
                        }}
                    >
                        {sanitizedCustomUrl ? (
                            <SovosButton
                                size="small"
                                variant="outlined"
                                color={theme.palette.common.black}
                                onClick={() => {
                                    history.push(dompurify.sanitize(sanitizedCustomUrl));
                                }}
                            >
                                {I18n.translate`View Details`}
                            </SovosButton>
                        ) : null}
                    </SovosBox>
                </SovosBox>
            ) : null}
        </SovosBox>
    );
};

export default FileMessageSalesSubmissionInformation;
